export default __webpack_public_path__ + "static/media/imgBannerInicio.aee4b08c.svg";